const removeGBP = ({ data }) => ({
  data: {
    ...data,
    currencies: data.currencies.filter(currency => currency.currency !== "GBP")
  }
});

export default removeGBP;
